export interface Props {
  color: string;
  hoverColor: string;
}

const Instagram = ({ color, hoverColor }: Props) => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        className={`size-5 lg:size-6 text-${color} duration-300 ease-in-out fill-current hover:text-${hoverColor}`}
      >
        <path
          fill=""
          fillRule="evenodd"
          d="M6.89 3A3.89 3.89 0 0 0 3 6.89v10.372a3.89 3.89 0 0 0 3.89 3.89h10.372a3.89 3.89 0 0 0 3.89-3.89V6.89A3.89 3.89 0 0 0 17.262 3H6.89Zm11.492 3.895a1.12 1.12 0 1 1-2.241 0 1.12 1.12 0 0 1 2.24 0Zm-6.306 2.073a3.107 3.107 0 1 0 0 6.215 3.107 3.107 0 0 0 0-6.215Zm-4.601 3.108a4.601 4.601 0 1 1 9.202 0 4.601 4.601 0 0 1-9.202 0Z"
          clipRule="evenodd"
        />
      </svg>
    </div>
  );
};

export default Instagram;
